import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class SuggestionCardItemAPI extends ComponentAPI {
    setFunctionToCallWaitingListModal(callToWaitlistModal) {
        this.setState({ callToWaitlistModal });
    }
    setFunctionToRemoveItemFromWaitingListModal(removeItemFromWaitingList) {
        this.setState({ removeItemFromWaitingList });
    }
    setFunctionToShowWaitingListModal(showWaitingListModal) {
        this.setState({ showWaitingListModal });
    }
}
//# sourceMappingURL=suggestion-card-api.js.map